<template>
  <div class="button-group" :class="[`button-group--type-${color}`]">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ButtonGroup',

  props: {
    color: {
      type: String,
      default: 'grey',
      validator(value) {
        return ['blue', 'grey', 'white'].indexOf(value) !== -1;
      },
    },
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
@use 'settings/settings';
.button-group {
  display: flex;
  position: relative;
  border-radius: settings.$border-radius;

  /* remove rounded corners between elements */
  .btn:not(:first-child),
  > :not(:first-child) .btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .btn:not(:last-child),
  > :not(:last-child) .btn {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}

.button-group--type-blue {
  gap: 1px;
  background: colors.$color-blue-tinted;
}

.button-group--type-grey {
  gap: 1px;
  background: colors.$color-grey-200;
}

.button-group--type-white {
  > :hover {
    z-index: 1;
  }

  > :not(:first-child) {
    margin-left: -1px;
  }
}
</style>
